import React from 'react';
import { DehydratedState, HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigation } from '../../components';
import { Footer } from '../../ui';
import { appRoutes } from './App.routes';
// Self-hosted (no Google Fonts request); Latin subset only, which covers æ, ø and å.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-400-italic.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import './app.scss';

export const App = ({ queryClient, state }: { queryClient: QueryClient, state?: DehydratedState }): React.ReactElement => {
  return (
    <React.Suspense fallback={ <div /> }>
      <QueryClientProvider client={ queryClient }>
        <HydrationBoundary state={ state }>
          <Navigation />

          <div style={ {
            width: '100vw',
            position: 'relative',
            height: '80px',
            display: 'block'
          } } />

          {/* Own boundary so the lazy route chunks don't hold back hydrating the navigation and footer. */}
          <React.Suspense fallback={ null }>
            {appRoutes}
          </React.Suspense>

          <Footer
            columns={ [{
              title: 'Models',
              links: [
                { text: 'BeoGram 400X', link: '/beogram/400x' },
                { text: 'BeoGram 7000 / 59xx', link: '/beogram/7000' },
                { text: 'BeoLink 7000', link: '/beolink/7000' },
                { text: 'Other models', link: '/other-models' }
              ]
            }, {
              title: 'Index',
              links: [
                { text: 'All parts', link: '/parts' },
                { text: 'All repairs', link: '/articles' },
                { text: 'GitHub', link: 'https://github.com/leicht-io' },
                { text: 'SpinDex', link: 'https://github.com/leicht-io/SpinDex' }
              ]
            }, {
              title: 'Help',
              links: [
                { text: 'Restoration', link: '/restoration-services' },
                { text: 'Sell your unit', link: '/sell-your-bang-olufsen' },
                { text: 'Contact', link: '/contact' }
              ]
            }, {
              title: 'More',
              links: [
                { text: 'Photography', link: '/photography/landscape-and-nature' },
                { text: 'USA', link: '/photography/united-states-of-america' },
                { text: 'Instagram', link: 'https://www.instagram.com/leicht.io' },
                { text: 'Facebook', link: 'https://www.facebook.com/LeichtIO-604758976689381/' }
              ]
            }] }
            bottomText={ `© ${ new Date().getFullYear() } Leicht Labs · VAT DK46656393 · Restoration and open-source parts for Bang & Olufsen` } />
        </HydrationBoundary>
      </QueryClientProvider>
    </React.Suspense>
  );
};
